
import AOS from 'aos';
import 'slick-carousel';

AOS.init( {
  once: true,
  anchorPlacement: 'top-bottom',
} );

import './parts/header';
import './parts/slider';
import './parts/address-finder';
import './parts/questions';

import './blocks/accordion';
import './custom-elements/paged-form';
import './custom-elements/modal';

//legacy
import './parts/slick-sliders';
import './parts/image-processing';

jQuery( window ).on( 'load', function() {
  AOS.refresh();
} );
